module.exports = __webpack_public_path__ + "img/desktop/Background-bonus/background_bonus@2x.jpg?0.0.53";